/**
 * @enum An enumeration mapping different product type which can be associated to an event.
 */
export const ObjectType = {
  Product: 'PRODUCT',
  Item: 'ITEM',
  MenuItem: 'MENU_ITEM',
};
